import { REDUX_CONSTANT } from '../../constants';
import * as TYPES from '../types';
import {
    PdfIcon,
    JsonIcon,
    HyperLinkIcon,
    DownloadIcon,
    CopyIcon
} from '../../constants/icon';
import { COMMON } from '../../constants';

const initialState = {
    isLoading: false,
    testModuleJsonData: undefined,
    testCardItems: [
        {
            type: 'item',
            name: 'PDF',
            icon: PdfIcon,
            additionalIcon: { src: DownloadIcon, alt: 'Download' }
        },
        {
            type: 'item',
            name: 'JSON',
            icon: JsonIcon,
            additionalIcon: { src: DownloadIcon, alt: 'Download' }
        },
        { type: 'header', name: 'Copy Deep link', icon: HyperLinkIcon },
        {
            type: 'item',
            name: 'Self-paced mode',
            additionalIcon: { src: CopyIcon, alt: 'Copy link' }
        },
        {
            type: 'item',
            name: 'Exam Mode',
            additionalIcon: { src: CopyIcon, alt: 'Copy link' }
        }
    ],
    testDownloadItems: [
        {
            name: COMMON.allPdf,
            icon: PdfIcon,
            additionalIcon: {
                src: DownloadIcon,
                alt: 'Download'
            },
            type: 'item'
        },
        {
            name: COMMON.allJson,
            icon: JsonIcon,
            additionalIcon: {
                src: DownloadIcon,
                alt: 'Download'
            },
            type: 'item'
        }
    ]
};

export default function getContentLibraryInformation(
    state = initialState,
    action
) {
    switch (action.type) {
        case REDUX_CONSTANT.GET_VENDOR_TEST_MODULES:
            let testModulesData =
                action.payload &&
                action.payload.items &&
                action.payload.items.length !== 0
                    ? action.payload.items
                    : [];
            return {
                ...state,
                vendorTestData: testModulesData,
                searchText: action.payload.searchText
                    ? action.payload.searchText
                    : '',
                pageNumber: action.payload.pageNumber,
                recordCount: action.payload.recordCount,
                pageSize: action.payload.pageSize,
                currentVendorId: action.payload.vendorId,
                isLoading: false
            };
        case TYPES.ON_LOAD:
            return {
                ...state,
                isLoading: true
            };
        case REDUX_CONSTANT.GET_VENDOR_TEST_JSON_DATA:
            return {
                ...state,
                testModuleJsonData: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.CLEAR_TEST_MODULE_JSON_DATA:
            return {
                ...state,
                testModuleJsonData: action.payload,
                isLoading: false
            };

        case REDUX_CONSTANT.GET_VENDOR_TEST_PDF_DATA:
            return {
                ...state,
                testModulePdfData: action.payload,
                isLoading: false
            };

        case REDUX_CONSTANT.GET_VENDOR_ALL_TEST_ZIP_DATA:
            return {
                ...state,
                testModuleZipData: action.payload,
                isLoading: false
            };

        case REDUX_CONSTANT.LOGOUT_RESET:
            state = initialState;
            return {
                ...state
            };

        case TYPES.ERROR:
            return {
                ...state,
                isLoading: false,
                vendorTestData:
                    action.payload.title ===
                    REDUX_CONSTANT.GET_VENDOR_TEST_MODULES
                        ? []
                        : state.testModulesData,
                testModuleJsonData:
                    action.payload.title ==
                    REDUX_CONSTANT.GET_VENDOR_TEST_JSON_DATA
                        ? action.payload
                        : state.testModuleJsonData,
                testModulePdfData:
                    action.payload.title ==
                    REDUX_CONSTANT.GET_VENDOR_TEST_PDF_DATA
                        ? action.payload.msg
                        : state.testModulePdfData,
                testModuleZipData:
                    action.payload.title ==
                    REDUX_CONSTANT.GET_VENDOR_ALL_TEST_ZIP_DATA
                        ? action.payload.msg
                        : state.testModuleZipData
            };
        default:
            return state;
    }
}
